import { render, staticRenderFns } from "./FlightSearch.vue?vue&type=template&id=028ead30&"
import script from "./FlightSearch.vue?vue&type=script&lang=js&"
export * from "./FlightSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports